// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"446ed33b","23":"8e7e364a","270":"54bc594c","453":"974aa1d5","597":"292d0fcb","824":"9c95f7ea","836":"46ce2663"}[chunkId] + ".chunk.js";
};